const articleTopGallery = new Swiper('.article-template__metafield-images', {
  spaceBetween: 20,
  slidesPerView: 1,
  loop: true,
  pagination: {
    el: '.article-template__metafield-images .swiper-pagination',
    clickable: true
  },
  breakpoints: {
    768: {
      spaceBetween: 10,
      slidesPerView: 4,
    }
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  }
});
const articleRecentPosts = new Swiper('.article-template__posts', {
  spaceBetween: 8,
  slidesPerView: 1.5,
  loop: true,
  breakpoints: {
    768: {
      spaceBetween: 9,
      slidesPerView: 4,
    }
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  }
});

let elem = document.querySelector('.article-template__products .gridz');
let infScroll = new InfiniteScroll( elem, {
  // options
  path: '.pagination__next',
  append: '.product-card',
  button: '.view-more-button',
  scrollThreshold: false,
});

let readMore = document.querySelector('.view-more-button');
readMore.onclick = function() {
  setTimeout(() => {
    let el = document.querySelectorAll('.article-prod-card');
    let count = 0;
    for(let i = 0; i < el.length; i++ ){
      if(el[i].offsetWidth > 0 && el[i].offsetHeight > 0){
        count++;
      }
    }
    document.querySelector('.prodCount').innerText = count;
  }, 1300);
}
